import { api } from 'app/config/apiConfig';
import { VerificationDocument } from '../model/types';

export const approveVerificationPhotoApi = api.injectEndpoints({
  endpoints: (builder) => ({
    approveVerificationPhoto: builder.mutation<VerificationDocument, string>({
      query: (verificationPhotoId: string) => ({
        url: `/verification-photos/${verificationPhotoId}/approve`,
        method: 'PUT',
      }),
      invalidatesTags: ['VerificationDocuments', 'Users'],
    }),
  }),
});

export const { useApproveVerificationPhotoMutation } = approveVerificationPhotoApi;
